import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `Wizard`,
  header: `WizardHeader`,
  headerPageDisabled: `WizardHeaderPageDisabled`,
  headerBadge: `WizardHeaderBadge`,
  headerBadgeActive: `WizardHeaderBadgeActive`,
  headerText: `WizardHeaderText`,
  content: `WizardContent`,
  actions: `WizardActions`
};

export function useWizardStyles(styleSet: IStyleSet) {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets(
      {
        root: [
          classNames.root,
          {
            height: `100%`,
            overflow: `hidden`,
            width: `100%`
          }
        ],
        header: [
          classNames.header,
          {
            padding: `0 5px 0 0`
          }
        ],
        headerPageDisabled: [classNames.headerPageDisabled, {}],
        headerBadge: [
          classNames.headerBadge,
          {
            backgroundColor: semanticColors.disabledBackground,
            border: `1px solid ${semanticColors.menuDivider}`,
            borderRadius: `20px`,
            minWidth: `11px`,
            padding: `0 10px`,
            textAlign: `center`
          }
        ],
        headerBadgeActive: [
          classNames.headerBadgeActive,
          {
            backgroundColor: semanticColors.primaryButtonBackground,
            border: `1px solid ${semanticColors.primaryButtonBorder}`,
            color: semanticColors.primaryButtonText,
            fontWeight: 800,
            padding: `0 9px`,
            [`& + .${classNames.headerText} > *`]: {
              fontWeight: 600
            }
          }
        ],
        headerText: [
          classNames.headerText,
          {
            lineHeight: `19px`,
            [`& > *`]: {
              color: semanticColors.disabledText
            }
          }
        ],
        content: [
          classNames.content,
          {
            overflow: `hidden`,
            overflowY: `scroll`,
            padding: `5px`
          }
        ],
        actions: [classNames.actions, {}]
      },
      styleSet
    ),
    [semanticColors, styleSet]
  );
}
